;(function ($) {
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init)

  let api = {}

  async function init() {
    combinedCharacterSteps()
    topActionBar.init()

    infoTabs()

    const getFrontendApi = await CPB.FrontendApi()
    api.frontend = new getFrontendApi()

    fontsThumbnails.init()
  }

  function infoTabs() {
    const product = CPB.getStore().getState().Product
    let category
    product.panels.find(panel => {
      category = panel.categories.find(category =>
        category.extraClassName.includes('info-tabs--js')
      )
      return category
    })
    if (!category) return
    const panelsContainer = $('.cpb-panels-container')
    const infoTabsWrapper = $(
      '<div class="cpb-custom-info-tabs-wrapper">'
    )
    const infoTabsTitles = $(
      '<div class="cpb-custom-info-tabs-titles">'
    )
    const infoTabsContent = $(
      '<div class="cpb-custom-info-tabs-content">'
    )
    let infoTabs = []
    category.options.forEach((option, i) => {
      const infoTabTitle = $(
        '<div class="cpb-custom-info-tab-titles__item">'
      ).text(option.option.data.label)
      const infoTabContent = $(
        '<div class="cpb-custom-info-tabs-content__item">'
      ).html(option.optionDescription)
      if (i === 0) {
        infoTabTitle.addClass('active')
        infoTabContent.addClass('active')
      }
      infoTabs.push({
        title: infoTabTitle,
        content: infoTabContent
      })
      infoTabsTitles.append(infoTabTitle)
      infoTabsContent.append(infoTabContent)

      infoTabTitle.on('click', function () {
        if (infoTabTitle.hasClass('active')) return
        infoTabs.forEach(tab => {
          tab.title.removeClass('active')
          tab.content.removeClass('active')
        })
        infoTabTitle.addClass('active')
        infoTabContent.addClass('active')
      })
    })

    infoTabsWrapper.append(infoTabsTitles, infoTabsContent)
    panelsContainer.append(infoTabsWrapper)
  }

  const topActionBar = {
    init() {
      const panelsContainer = $('.cpb-panels-container')
      const bar = $('<div class="cpb-custom-top-action-bar">')
      const description = panelsContainer
        .find('.cpb-product-description')
        .hide()

      priceClone.init(bar)

      if (description.length > 0) {
        const descriptionBtn = $(
          '<button class="cpb-custom-toggle-description cpb-custom-button">'
        ).text('See Product Description >')
        descriptionBtn.on('click', function () {
          description.toggle()
        })

        bar.append(descriptionBtn)
      }

      panelsContainer.append(bar)
    }
  }

  const priceClone = {
    init(parentElement) {
      const panelsContainer = $('.cpb-panels-container')
      const priceEl = panelsContainer.find('.cpb-product-price')
      const clone = $('<div class="cpb-custom-product-price">').text(
        priceEl.text()
      )

      const observer = new MutationObserver(function () {
        clone.text(priceEl.text())
      })

      observer.observe(priceEl[0], {
        characterData: true,
        subtree: true
      })

      if (parentElement) parentElement.append(clone)
      else panelsContainer.append(clone)

      $('#product-builder').attr('data-cpb-custom-price', true)
    }
  }

  const fontsThumbnails = {
    fontsInProduct: false,
    init() {
      this.loadFonts()
      this.update()
      document.body.addEventListener(
        'CPB_ON_OPTIONS_UPDATE',
        this.update.bind(this)
      )
      document.body.addEventListener(
        'CPB_ON_UPDATE_CURRENT_TAB',
        this.update.bind(this)
      )
    },
    update() {
      const that = this
      const fontCategories = $(
        '.cpb-category-fontFamily:not([data-cpb-custom-processed="true"])'
      )
      fontCategories.each(function () {
        const category = $(this)
        if (category.attr('data-cpb-custom-processed') === 'true')
          return
        category.find('.cpb-category-options-container').hide()
        const objects = getState.panelCategoryByCategoryElement(this)
        const inStockOptions = objects.category.options.filter(
          option => option.inStock
        )
        const container = $(
          '<div class="cpb-custom-category-options-container cpb-custom-category-font">'
        )
        that.fontsInProduct.forEach(font => {
          const optionEl = $(
            '<button class="cpb-custom-option-font" data-font="' +
              font +
              '" style="font-family: ' +
              font +
              '">'
          ).text(font)
          if (
            objects.category.options[0].option.data
              .defaultSelectValue === font
          )
            optionEl.addClass('active')
          container.append(optionEl)
          optionEl.on('click', function () {
            if (!api.frontend) return
            let option = objects.category.options[0]
            option.option.data.value = font
            api.frontend.updateOptions({
              panel: objects.panel,
              category: objects.category,
              options: [option]
            })
            container
              .find('.cpb-custom-option-font')
              .removeClass('active')
            optionEl.addClass('active')
          })
        })
        category.find('.cpb-category-content').append(container)
        category.attr('data-cpb-custom-processed', true)
      })
    },
    loadFonts() {
      const state = CPB.getStore().getState()
      const fontsInProduct = state.App.settings.fonts.available
      this.fontsInProduct = fontsInProduct
      const customFonts = state.Global.fonts
      const customAvailable = customFonts.filter(font =>
        fontsInProduct.includes(font.name)
      )
      const customAvailableNames = customAvailable.map(
        font => font.name
      )
      const builtInAvailable = fontsInProduct.filter(
        fontName => !customAvailableNames.includes(fontName)
      )
      if (builtInAvailable.length) {
        let style =
          '<style>@import url("https://fonts.googleapis.com/css2?'
        builtInAvailable.forEach(font => {
          style += 'family=' + font.replace(/ /i, '+') + '&'
        })
        style += 'display=swap");</style>'
        $('body').append($(style))
      }
      customAvailable.forEach(font => {
        new FontFace(font.name, 'url(' + font.file + ')')
          .load()
          .then(function (loaded_face) {
            document.fonts.add(loaded_face)
          })
      })
    }
  }

  function combinedCharacterSteps() {
    const product = CPB.getStore().getState().Product
    const panelObjects = product.panels.filter(panel =>
      panel.extraClassName.includes('cpb-custom-character')
    )

    updateDOM()
    document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', updateDOM)
    function updateDOM() {
      panelObjects.forEach(panelObject => {
        const panelInDOM = $(
          `.cpb-custom-character[data-panel-id="${panelObject.id}"]:not([data-cpb-custom-combined-category="true"])`
        )
        if (panelInDOM.length === 0) return
        new CombinedCharacterStep(panelObject)
      })
    }
  }

  const getState = {
    categoryId(el) {
      for (let i = 0; i < el.classList.length; i++) {
        if (el.classList.contains('cpb-category-' + el.classList[i]))
          return el.classList[i]
      }
      return false
    },
    panelCategoryByCategoryId(id) {
      if (!id) return { panel: false, category: false }
      const panels = CPB.getStore().getState().Product.panels
      let category = false
      const panel = panels.find(panel => {
        category = panel.categories.find(
          category => category.id === id
        )
        return category
      })
      return category
        ? { panel, category }
        : { panel: false, category: false }
    },
    panelCategoryByCategoryElement(el) {
      return this.panelCategoryByCategoryId(this.categoryId(el))
    },
    isCategoryShown(
      categoryObj,
      product = CPB.getStore().getState().Product
    ) {
      if (categoryObj.logic.rules.length === 0) return true
      let action = categoryObj.logic.action
      let rulesString = ''
      for (let i = 0; i < categoryObj.logic.rules.length; i++) {
        const rule = categoryObj.logic.rules[i]
        const rulePasses = product.layers.find(
          layer => layer.option === rule.option
        )
        if (i !== 0) rulesString += rule.operator
        rulesString += !!rulePasses
      }
      if (action === 'show' && eval(rulesString)) return true
      else if (action === 'hide' && !eval(rulesString)) return true
      return false
    },
    isCategoryFilled(
      categoryObj,
      product = CPB.getStore().getState().Product
    ) {
      return !!product.layers.find(
        layer => layer.category === categoryObj.id
      )
    },
    isPanelFilled(
      panelObj,
      product = CPB.getStore().getState().Product
    ) {
      let shownCategories = 0
      let filledCategories = 0
      for (let i = 0; i < panelObj.categories.length; i++) {
        const category = panelObj.categories[i]
        if (getState.isCategoryShown(category)) {
          shownCategories++
          if (getState.isCategoryFilled(category)) {
            filledCategories++
          }
        }
      }
      return (
        shownCategories > 0 && shownCategories === filledCategories
      )
    }
  }

  class CombinedCharacterStep {
    constructor(panelObj) {
      this.panelObj = panelObj
      if (this.panelObj === undefined) return

      this.characterCategories = []
      this.categoryNames = []
      this.selectedCategory = 'All'
      this.slider = { swiper: false, sliderHtmlObj: false }

      this.fillCharacterCategories()
      const appEl = this.createCombinedCategory()

      const firstCategory = $(
        '.cpb-category.' + this.panelObj.categories[0].id
      )
      const panel = firstCategory.closest('.cpb-panel-wrapper')

      firstCategory.before(appEl)
      panel.attr('data-cpb-custom-combined-category', true)

      this.slider.swiper = new Swiper('.swiper', {
        slidesPerView: 6,
        grid: {
          rows: 2
        },
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      })
    }
    fillCharacterCategories() {
      const that = this
      this.panelObj.categories.forEach(function (category, i) {
        const categoryEl = $('.cpb-category.' + category.id)
        const options = categoryEl.find('.cpb-option-type-img')

        that.characterCategories[i] = {
          name: category.title,
          options: []
        }

        options.each(function () {
          const option = $(this)
          const img = option.find('.cpb-option-tooltip-img')
          const optionName = option.find('.cpb-option-label').text()
          const optionObj = category.options.find(
            option => option.option.data.label === optionName
          )
          const optionImgSrc = optionObj.option.data.value

          const optionClone = $(
            '<div class="cpb-custom-option swiper-slide">'
          )
          const optionCloneImg = $(
            '<img class="cpb-custom-option__img">'
          )
            .attr('alt', optionName)
            .attr('src', optionImgSrc)
            .attr('loading', 'lazy')

          if (option.hasClass('cpb-active'))
            optionClone.addClass('active')

          optionClone[0].addEventListener('click', function () {
            option.trigger('click')
          })
          document.body.addEventListener(
            'CPB_ON_OPTIONS_UPDATE',
            function () {
              setTimeout(function () {
                if (option.hasClass('cpb-active'))
                  optionClone.addClass('active')
                else optionClone.removeClass('active')
              })
            }
          )

          optionClone.append(optionCloneImg)

          that.characterCategories[i].options.push({
            name: optionName,
            element: optionClone
          })
        })
      })
    }
    createCombinedCategory() {
      const that = this
      const wrapperEl = $(
        '<div class="cpb-custom-combined-character">'
      )
      const categoryNamesEl = $(
        '<div class="cpb-custom-combined-character__category-names cpb-custom-combined-character-category-names">'
      )
      const shownCharactersEl = $(
        '<div class="cpb-custom-combined-character__characters cpb-custom-combined-character-characters">'
      )
      const sliderContainerEl = $(
        '<div class="cpb-custom-combined-character-slider-container">'
      )
      const sliderContainerInnerEl = $(
        '<div class="cpb-custom-combined-character-slider-container__inner">'
      )

      let catNameItem = this.createCharacterNameItem('All')
      catNameItem.element.on(
        'click',
        this.setActiveCategoryNameItem.bind(this, catNameItem.name)
      )
      this.categoryNames.push(catNameItem)
      categoryNamesEl.append(catNameItem.element)

      this.characterCategories.forEach(function (category) {
        let catNameItem = that.createCharacterNameItem(category.name)
        catNameItem.element.on(
          'click',
          that.setActiveCategoryNameItem.bind(that, catNameItem.name)
        )
        that.categoryNames.push(catNameItem)
        categoryNamesEl.append(catNameItem.element)
      })

      this.slider.sliderHtmlObj = this.createSliderHTML()
      this.renderSlides()
      shownCharactersEl.append(
        sliderContainerEl.append(
          sliderContainerInnerEl.append(
            this.slider.sliderHtmlObj.swiper
          )
        )
      )
      wrapperEl.append(categoryNamesEl, shownCharactersEl)
      this.setActiveCategoryNameItem(this.selectedCategory)

      return wrapperEl
    }
    getSlidesToShow() {
      let slidesToShow = []
      let categories = []

      if (this.selectedCategory == 'All') {
        categories = this.characterCategories
      } else {
        const category = this.characterCategories.find(
          category => category.name === this.selectedCategory
        )
        categories = category ? [category] : []
      }

      categories.forEach(function (category) {
        category.options.forEach(function (option) {
          slidesToShow.push(option.element)
        })
      })

      return slidesToShow
    }
    setActiveCategoryNameItem(name) {
      const selectedBefore = this.selectedCategory
      this.selectedCategory = name
      this.categoryNames.forEach(function (item) {
        item.element.removeClass('active')
      })
      this.categoryNames
        .find(item => item.name === name)
        .element.addClass('active')
      if (selectedBefore === name) return
      this.renderSlides()
    }
    renderSlides() {
      const that = this
      that.slider.sliderHtmlObj.slidesWrapper.empty()
      this.getSlidesToShow().forEach(function (slide) {
        that.slider.sliderHtmlObj.slidesWrapper.append(slide)
      })
      this.slider.sliderHtmlObj.swiper?.[0]?.swiper?.update()
    }
    createCharacterNameItem(name) {
      const nameEl = $(
        '<div class="cpb-custom-combined-character-category-names__item">'
      )
      nameEl.html($('<span>').text(name))
      return { name, element: nameEl }
    }
    createSliderHTML() {
      const swiper = $('<div class="swiper">')
      const slidesWrapper = $('<div class="swiper-wrapper">')

      swiper
        .append(slidesWrapper)
        .append(
          '<div class="swiper-button-prev"></div><div class="swiper-button-next"></div>'
        )
      return { swiper, slidesWrapper }
    }
  }
})(jQuery)
